import PropTypes from 'prop-types';
import isNilOrEmpty from "ramda-extension/es/isNilOrEmpty";
import React from 'react';
import Cross from '../../SvgIcon/Icons/Cross';
import InputControl from '../../TextField/InputControl';
const SelectPanelControls = ({ controlPanelIconOpen, controlPanelIconClose, clearable, disabled, isOpen, value, readOnly, onClear, onSelect, additionalPanelControlElement })=>{
    const hasValue = !isNilOrEmpty(value);
    return /*#__PURE__*/ React.createElement("div", {
        className: "Input-controlPanel-items"
    }, clearable && !disabled && !readOnly && hasValue ? /*#__PURE__*/ React.createElement(InputControl, {
        icon: /*#__PURE__*/ React.createElement(Cross, null),
        className: "Select-clearButton",
        onClick: onClear
    }) : null, controlPanelIconOpen && !isOpen ? /*#__PURE__*/ React.createElement(InputControl, {
        disabled: disabled,
        readOnly: readOnly,
        icon: controlPanelIconOpen,
        onClick: onSelect
    }) : null, controlPanelIconClose && isOpen ? /*#__PURE__*/ React.createElement(InputControl, {
        disabled: disabled,
        readOnly: readOnly,
        icon: controlPanelIconClose,
        onClick: onSelect
    }) : null, additionalPanelControlElement);
};
SelectPanelControls.propTypes = {
    additionalPanelControlElement: PropTypes.object,
    /**
	 * If true, component will contains clear button
	 */ clearable: PropTypes.bool,
    /**
	 * Icon which is displayed in control panel when control panel is open.
	 * It can be String representation of Icon component or Icon component itself
	 */ controlPanelIconClose: PropTypes.node,
    /**
	 * Icon which is displayed in control panel when control panel is closed.
	 * It can be String representation of Icon component or Icon component itself
	 */ controlPanelIconOpen: PropTypes.node,
    /**
	 * If true, component will not be active
	 */ disabled: PropTypes.bool,
    /**
	 * If true, controlPanelIconClose icon will be shown.
	 * Otherwise will be shown controlPanelIconOpen icon.
	 */ isOpen: PropTypes.bool,
    /**
	 * onClear callback
	 * @param {object} event event targeting the element.
	 */ onClear: PropTypes.func,
    /**
	 * onClear callback
	 * @param {object} event event targeting the element.
	 */ onSelect: PropTypes.func,
    /**
	 * If true, component will not be active
	 */ readOnly: PropTypes.bool,
    /**
	 * Value of select
	 */ value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.array,
        PropTypes.object,
        PropTypes.bool
    ])
};
export default SelectPanelControls;
